import { Routes } from '.generated/templates/Project.Routes.model';
import { isGenericObjectType } from 'lib/typescript';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import {
  NavPageOrLink,
  NavPageOrLinkWithChildren,
  NavigationLink,
  GenericPage,
  NavigationHeader,
} from './_types';
import { Data } from '.generated/templates/Feature.Data.model';

export const isGenericPageFields = (
  check: unknown
): check is Sitecore.Override.ItemFields<Routes.Fields.GenericPage> => {
  return isGenericObjectType<Sitecore.Override.ItemFields<Routes.Fields.GenericPage>>(
    check,
    [
      ['pageTitle', 'object'],
      ['navigationTitle', 'object'],
    ],
    false
  );
};

export const isNavigationLinkFields = (
  check: unknown
): check is Sitecore.Override.ItemFields<Data.Navigation.Fields.NavigationLink> =>
  isGenericObjectType<Sitecore.Override.ItemFields<Data.Navigation.Fields.NavigationLink>>(check, [
    ['navigationItemLink', 'object'],
  ]);

const isItemEx = (check: unknown): check is Sitecore.Override.ItemEx =>
  isGenericObjectType<Sitecore.Override.ItemEx>(check, [
    ['fields', 'object'],
    ['name', 'string'],
    ['id', 'string'],
  ]);

export const isGenericPage = (check: unknown): check is GenericPage =>
  isItemEx(check) && 'url' in check && isGenericPageFields(check.fields);

export const isNavigationLink = (check: unknown): check is NavigationLink =>
  isItemEx(check) && isNavigationLinkFields(check.fields);

export const isNavPageOrLink = (check: unknown): check is NavPageOrLink =>
  isNavigationLink(check) || isGenericPage(check);

export const isNavPageOrLinkWithChildren = (check: unknown): check is NavPageOrLinkWithChildren =>
  isNavPageOrLink(check) && 'children' in check && Array.isArray(check.children);

const isNavigationHeaderFields = (check: unknown): check is Required<NavigationHeader>['fields'] =>
  isGenericObjectType<Sitecore.Override.ItemFields<NavigationHeader>>(check, [
    ['description', 'object'],
    ['navigationHeading', 'object'],
    ['navigationLink', 'object'],
  ]);

export const isNavigationHeader = (check: unknown): check is NavigationHeader =>
  isItemEx(check) && isNavigationHeaderFields(check.fields);
